module.exports = __webpack_public_path__ + "static/media/training_hero_hands_dance_sunlight.aece7fb7.webp";